/* eslint-disable no-loop-func */
import SpaceBetween from "@cloudscape-design/components/space-between";
import {
  Box,
  Table,
  Button,
  TextFilter,
  Pagination,
  CollectionPreferences,
  ColumnLayout,
  Container,
  Header,
  Link,
  StatusIndicator,
  AppLayout,
  BreadcrumbGroup,
  ContentLayout,
  HelpPanel,
  Icon,
  SplitPanel,
  Spinner,
} from "@cloudscape-design/components";

import Grid from "@cloudscape-design/components/grid";

import { useEffect, useState } from "react";

import { Amplify } from "aws-amplify";
import { generateClient } from "aws-amplify/api";
import config from "../../../amplifyconfiguration.json";
import UserChart from "./component/userchart";
import VariationTable from "./component/listUser";
import { ListUser } from "./data/data";
import { Navigation } from "../../../components/app/Navigation";
import React from "react";
import { listAdmins } from "../../../graphql/queries";
import { onCreateAdmin } from "../../../graphql/subscriptions";
import { ListAdminsQueryVariables } from "../../../API";

Amplify.configure(config);
function DashboardAdmin() {
  const [total_user, setTotalUser] = useState(0);
  const [totalAdmin, setTotalAdmin] = useState(0);
  const [total_userGuest, setTotalUserGuest] = useState(0);
  const [totalOperator, setTotalOperator] = useState(0);
  const [activeHref, setActiveHref] = React.useState("/admin");
  const [helpPanelOpen, setHelpPanelOpen] = useState(false); // State untuk mengontrol panel bantuan
  const [listUser, setListUser] = useState<ListUser[]>([]);
  const [isLoading, setIsLoading] = React.useState(true);
  //graphql apis
  useEffect(() => {
    //currentAuthenticatedUser();
    fetchOverview();
  }, []);

  async function fetchOverview(limit = 100) {
    try {
      const client = generateClient();
      let nextToken: string | null = null;
      let allUsers: ListUser[] = [];
      let adminCount = 0;
      let operatorCount = 0;
      let userCount = 0;

      do {
        const variables: ListAdminsQueryVariables = { limit, nextToken };
        let response = await client.graphql({
          query: listAdmins,
          authMode: "userPool",
          variables,
        });

        const admins = response.data.listAdmins.items;
        nextToken = response.data.listAdmins.nextToken ?? null;

        const newUsers: ListUser[] = admins.map((admin) => {
          const accessRole = admin["accessrole"] ?? "";

          // Count based on role
          if (accessRole === "Admin") {
            adminCount++;
          } else if (accessRole === "Operator") {
            operatorCount++;
          } else if (accessRole === "User") {
            userCount++;
          }

          return {
            id: admin["id"],
            NIK: admin["nik"] ?? "",
            Name: admin["name"] ?? "",
            Email: admin["email"] ?? "",
            Position: admin["position"] ?? "",
            tenant: admin["tenant"] ?? "",
            Username: admin["username"] ?? "",
            Password: admin["password"] ?? "",
            AccessRole: accessRole,
          };
        });

        allUsers = [...allUsers, ...newUsers];
      } while (nextToken);

      setListUser(allUsers);
      setTotalUser(allUsers.length);
      setTotalAdmin(adminCount);
      setTotalOperator(operatorCount);
      setTotalUserGuest(userCount);
      setIsLoading(false);
    } catch (err) {
      console.log("error fetching data: ", err);
    }
  }
  return (
    <>
      <AppLayout
        breadcrumbs={
          <BreadcrumbGroup
            items={[
              {
                text: "Admin",
                href: "/admin/users",
              },
              {
                text: "Overview",
                href: "/admin",
              },
            ]}
          />
        }
        navigation={
          <Navigation
            activeHref={activeHref}
            setActiveHref={setActiveHref}
            adminSubMenuOpen={false}
            setAdminSubMenuOpen={function (href: boolean): void {
              throw new Error("Function not implemented.");
            }} // adminSubMenuOpen={adminSubMenuOpen} // Mengirim state submenu Admin ke komponen Navigation
            // setAdminSubMenuOpen={setAdminSubMenuOpen} // Mengirim fungsi untuk mengubah state submenu Admin ke komponen Navigation
          />
        }
        toolsOpen={helpPanelOpen} // Menggunakan state untuk menentukan apakah panel bantuan terbuka atau tidak
        onToolsChange={() => setHelpPanelOpen(!helpPanelOpen)}
        tools={
          <HelpPanel
            footer={
              <div>
                <h3>
                  Learn more <Icon name='external' />
                </h3>
                <ul>
                  <li>
                    <a href=''>Link to documentation</a>
                  </li>
                  <li>
                    <a href=''>Link to documentation</a>
                  </li>
                </ul>
              </div>
            }
            header={<h2>Help panel title (h2)</h2>}
          >
            <div>
              <p>
                This is a paragraph with some <b>bold text</b> and also some{" "}
                <i>italic text</i>.
              </p>

              <h3>h3 section header</h3>
              <ul>
                <li>Unordered list item.</li>
                <li>Unordered list item.</li>
              </ul>

              <h4>h4 section header</h4>
              <p>
                Code can be formatted as lines of code or blocks of code. Add
                inline code <code>like this</code> using a{" "}
                <code>{"<code>"}</code> tag.
                <pre>
                  Or format blocks of code (like this) using a{" "}
                  <code>{"<pre>"}</code> tag.
                </pre>
              </p>

              <h5>h5 section header</h5>
              <dl>
                <dt>This is a term</dt>
                <dd>This is its description.</dd>
                <dt>This is a term</dt>
                <dd>This is its description</dd>
              </dl>
            </div>
          </HelpPanel>
        }
        content={
          <ContentLayout
            header={
              <Header
                variant='h1'
                info={
                  <Link
                    variant='info'
                    onFollow={() => setHelpPanelOpen(!helpPanelOpen)}
                  >
                    Info
                  </Link>
                }
              >
                {activeHref === "/admin" ? `Dashboard Admin ` : ""}
              </Header>
            }
          >
            <div className='contentPlaceholder'>
              <SpaceBetween size='l'>
                <Grid
                  gridDefinition={[
                    { colspan: { default: 12, xxs: 8 } },
                    { colspan: { default: 12, xxs: 4 } },
                    { colspan: { default: 12, xxs: 12 } },
                  ]}
                >
                  <Container
                    header={
                      <Header variant='h2' description='Summary of total users'>
                        Overview
                      </Header>
                    }
                    fitHeight={true}
                  >
                    <ColumnLayout
                      columns={4}
                      variant='text-grid'
                      minColumnWidth={100}
                    >
                      <div>
                        <Box variant='awsui-key-label'>Total Users</Box>
                        <Link
                          variant='awsui-value-large'
                          href='#'
                          ariaLabel='Running instances (14)'
                        >
                          {total_user}
                        </Link>
                      </div>
                      <div>
                        <Box variant='awsui-key-label'>User/Guest</Box>
                        <Link
                          variant='awsui-value-large'
                          href='#'
                          ariaLabel='Running instances (14)'
                        >
                          {total_userGuest}
                        </Link>
                      </div>
                      <div>
                        <Box variant='awsui-key-label'>Operator</Box>
                        <Link
                          variant='awsui-value-large'
                          href='#'
                          ariaLabel='Volumes (126)'
                        >
                          {totalOperator}
                        </Link>
                      </div>
                      <div>
                        <Box variant='awsui-key-label'>Admin</Box>
                        <Link
                          variant='awsui-value-large'
                          href='#'
                          ariaLabel='Volumes (126)'
                        >
                          {totalAdmin}
                        </Link>
                      </div>
                    </ColumnLayout>
                  </Container>
                  {isLoading ? (
                    <Container>
                    <Box textAlign='center' padding="xl">
                      <Spinner size='large' />
                      <Box variant='p'>Loading users data...</Box>
                    </Box>
                    </Container>
                  ) : (
                    <UserChart ListUser={listUser}  />
                  )}
                  
                  {isLoading ? (
                    <Box textAlign='center'>
                      <Spinner size='large' />
                      <Box variant='p'>Loading users data...</Box>
                    </Box>
                  ) : (
                    <VariationTable ListUser={listUser} />
                  )}
                  
                </Grid>
              </SpaceBetween>
            </div>
          </ContentLayout>
        }
        splitPanel={
          <SplitPanel header='Split panel header'>
            Split panel content
          </SplitPanel>
        }
      />
    </>
  );
}

export default DashboardAdmin;
